export default "/images/qrcode.svg"